import { Dispatch, SetStateAction } from "react";
import { SelectProps } from "@amzn/awsui-components-react";
export interface ICreateTaskFormProps {
  parentTaskId: string;
  setVisible: Dispatch<SetStateAction<boolean>>;
  resetForm: number;
  parentCategory: string;
  onCreate?: (taskData: any) => void;
}

export interface CreateTaskFormResponse {
  taskId: string;
}

export enum TaskStatus {
  NotStarted = "Not started",
  InProgress = "In progress",
  OnHold = "On hold",
  Complete = "Complete",
}

export type StatusChangeEvent = Parameters<
  Required<SelectProps>["onChange"]
>[0];
